// Single source of truth for Doctor & Nurse specializations.
// Used by ProviderDashboard (signup/edit), Search (filter), and ClinicDashboard.
// IMPORTANT: When adding a new specialization, also consider adding an icon to Home.js category cards.

export const DOCTOR_SPECIALIZATIONS = [
  // Primary care
  { value: 'general ', label: 'General Physician' },
  { value: 'family_medicine', label: 'Family Medicine' },
  { value: 'pediatrics', label: 'Pediatrician' },
  { value: 'gynecology', label: 'Gynecologist' },

  // Specialist doctors
  { value: 'cardiology', label: 'Cardiologist' },
  { value: 'dermatology', label: 'Dermatologist (Skin Care)' },
  { value: 'neurology', label: 'Neurologist' },
  { value: 'orthopedics', label: 'Orthopedic Surgeon' },
  { value: 'ophthalmology', label: 'Ophthalmologist (Eye)' },
  { value: 'ent', label: 'ENT Specialist' },
  { value: 'psychiatry', label: 'Psychiatrist' },
  { value: 'diabetology', label: 'Diabetologist' },
  { value: 'endocrinology', label: 'Endocrinologist' },
  { value: 'urology', label: 'Urologist' },
  { value: 'gastroenterology', label: 'Gastroenterologist' },
  { value: 'pulmonology', label: 'Pulmonologist (Lungs)' },
  { value: 'nephrology', label: 'Nephrologist (Kidney)' },
  { value: 'oncology', label: 'Oncologist (Cancer)' },
  { value: 'plastic_surgery', label: 'Plastic Surgeon' },
  { value: 'general_surgery', label: 'General Surgeon' },

  // Dental & therapy
  { value: 'dentistry', label: 'Dentist' },
  { value: 'physiotherapy', label: 'Physiotherapist' },
  { value: 'sports_medicine', label: 'Sports Medicine' },

  // Alternative medicine
  { value: 'ayurveda', label: 'Ayurvedic Doctor' },
  { value: 'homeopathy', label: 'Homeopathic Doctor' },

  // Wellness & specialty
  { value: 'nutrition', label: 'Nutritionist / Dietitian' },
  { value: 'psychology', label: 'Psychologist' },
  { value: 'sexology', label: 'Sexologist' },
  { value: 'fertility', label: 'IVF / Fertility Specialist' },
  { value: 'speech_therapy', label: 'Speech Therapist' },
  { value: 'audiology', label: 'Audiologist (Hearing)' },
];

export const NURSE_SPECIALIZATIONS = [
  { value: 'general_nursing', label: 'General Nursing' },
  { value: 'icu_care', label: 'ICU Care' },
  { value: 'home_care', label: 'Home Care' },
  { value: 'pediatric_care', label: 'Pediatric Care' },
  { value: 'elderly_care', label: 'Elderly Care' },
  { value: 'maternity_care', label: 'Maternity Care' },
  { value: 'wound_care', label: 'Wound Care' },
  { value: 'dialysis', label: 'Dialysis Care' },
  { value: 'physiotherapy', label: 'Physiotherapy Assistance' },
  { value: 'post_surgery', label: 'Post Surgery Care' },
  { value: 'palliative_care', label: 'Palliative Care' },
  { value: 'night_duty', label: 'Night Duty Nurse' },
  { value: 'injection_iv', label: 'Injection / IV Care' },
  { value: 'newborn_care', label: 'Newborn / Baby Care' },
];

// Helper to find label from value (handles legacy values gracefully)
export const getSpecializationLabel = (value, role = 'doctor') => {
  if (!value) return '';
  const list = role === 'nurse' ? NURSE_SPECIALIZATIONS : DOCTOR_SPECIALIZATIONS;
  const found = list.find((s) => s.value === value);
  if (found) return found.label;
  // Legacy fallback for old values like 'dental' or 'sport medicine'
  const legacyMap = {
    dental: 'Dentist',
    'sport medicine': 'Sports Medicine',
  };
  return legacyMap[value] || value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};
